<template>
    <!-- eslint-disable max-len -->
    <div class="bpc-page-top d-flex justify-content-between bd-highlight">
        <nav class="bpc-breadcrumb" aria-label="breadcrumb">
            <ol class="breadcrumb">
              <template v-for="(item, index) in breadcrumb" :item="item" :index="index">
                <li class="breadcrumb-item" :key="item" v-if="index != breadcrumb.length - 1">
                  <!-- <router-link to="/mockups/admin/contacts/1" -->
                  <b-link to="/mockups/admin/contacts" class="btn-link">{{item}}</b-link>
                  <!-- <a href="javascript:void(0);" class="btn-link">{{item}}</a> -->
                </li>
                <li class="breadcrumb-item active" :key="item" v-else>
                  {{item}}
                </li>
              </template>
            </ol>
        </nav>
        <nav class="nav bpc-top-links">
          <template v-for="(link, index) in links" :item="link" :index="index">
            <a :key="link" class="nav-link btn-link" href="javascript:void(0);">{{link}}</a>
          </template>
        </nav>
    </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    breadcrumb: Array,
    links: Array,
  },
};
</script>

<style scoped>
  .bpc-page-top {
    margin: -30px -30px 0;
    padding: 15px 30px 0;
    background-color: rgba(255, 255, 255, 0.45); 
    /* background-color: rgb(240, 243, 245); */
  }
  ol.breadcrumb {
    background-color: transparent;
  }
  .d-flex > *, .d-inline-flex > * {
      flex: none !important;
  }
  ol.breadcrumb {
    border-radius: 0;
    padding: 0.75rem 1.25rem;
    margin: 0;
    padding: 0;
  }
  nav.bpc-top-links .nav-link {
    font-weight: normal;
    padding: 0 0 0 15px;
  }
  .btn-link {
    font-weight: normal;
  }
  nav.bpc-top-links .nav-link:hover, .btn-link:hover {
    text-decoration: underline;
  }
</style>
